import { quickNews, dataPanel } from '@/mocks/home';

const toneBar: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function FeedPanel() {
  return (
    <section id="feed" className="bg-background-100/60 border-b border-background-200">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              今日速报
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              短讯并行更新，先扫一眼时间线，再决定点开哪一条。
            </p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500 shrink-0">
            <i className="ri-refresh-line" />
            滚动更新中
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          <div className="lg:col-span-8 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <ul className="divide-y divide-background-200">
              {quickNews.map((item) => (
                <li key={`${item.time}-${item.text}`} className="flex items-start gap-3 md:gap-4 px-4 py-3.5 hover:bg-background-100/70 transition-colors cursor-pointer">
                  <span className="w-12 shrink-0 font-heading text-sm font-bold text-foreground-500 pt-0.5">
                    {item.time}
                  </span>
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" />
                  <p className="flex-1 text-sm text-foreground-900 leading-relaxed">{item.text}</p>
                  <span className="hidden sm:inline-flex shrink-0 text-[11px] text-secondary-900 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-center gap-2">
              <span className="w-7 h-7 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
                <i className="ri-bar-chart-2-line" />
              </span>
              <h3 className="text-sm font-bold text-foreground-950">本期数据面板</h3>
            </div>
            <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
              按档案整理进度计算的参考值，用于快速判断哪条值得细看。
            </p>

            <div className="mt-5 space-y-4">
              {dataPanel.map((meter) => (
                <div key={meter.label}>
                  <div className="flex items-center justify-between text-xs mb-1.5">
                    <span className="text-foreground-700">{meter.label}</span>
                    <span className="font-heading font-bold text-foreground-950">{meter.value}</span>
                  </div>
                  <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
                    <div
                      className={`h-full rounded-full ${toneBar[meter.tone] ?? 'bg-primary-500'}`}
                      style={{ width: `${meter.value}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-5 pt-4 border-t border-background-200 flex items-center gap-2 text-xs text-foreground-600">
              <i className="ri-information-line text-secondary-700" />
              数据为演示参考值，不代表事实结论。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}